import React, { useContext } from "react";
import { FilterContext } from "../../context/Filter";

const Contentcards = ({ heading, content }) => {
  const { open } = useContext(FilterContext); // ✅ move inside function body

  return (
    <div className={` ${open ? 'w-[1000px]' : 'w-full'}`}>
      <div className={`block w-96 md:w-full flex border rounded-xl shadow-md bg-white pt-1  mb-2`}>
        <div className="flex flex-col w-full">
          <div className="text-center text-sm font-semibold">{heading}</div>

          <div className="w-full">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default Contentcards;
